import {PageBody, PageContent, PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {Header} from '@/components/commons/header/Header'
import {Divider} from '@/components/ui/divider/Divider'
import {DashboardTabs} from '@/features/dashboard/components/dashboard-tabs/DashboardTabs'
import {DashboardExportButton} from '@/features/dashboard/components/dashboard-export-button/DashboardExportButton'
import {Navigate, Outlet} from 'react-router-dom'
import {StyledDashboardWrapper} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {usePermissions} from '@/features/auth/store/store'
import {routes} from '@/utilities/constants/routes'

export const DashboardLayout = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()

    // Redirect users without settings access to home
    if (!permissions?.settings?.read) {
        return <Navigate to={routes.HOME.path} replace />
    }

    return (
        <PageBody>
            <Header />
            <Divider direction="horizontal" />
            <PageContent>
                <StyledDashboardWrapper>
                    <Flexbox direction="column" fullWidth>
                        <PageHeading justify="space-between" align="center" fullWidth>
                            <h2>{t('commons:dashboard')}</h2>
                            <DashboardExportButton />
                        </PageHeading>
                        <DashboardTabs />
                    </Flexbox>

                    <Outlet />
                </StyledDashboardWrapper>
            </PageContent>
        </PageBody>
    )
}
